module.exports = __webpack_public_path__ + "media/assets/bookshelf-skeleton-ee6262de8bf250ea04ba17ae926c4d7a.svg";